import IconWithBackground from '../IconWithBackground/IconWithBackground'
import { faReceipt } from '@fortawesome/pro-solid-svg-icons'
import { useEffect, useState } from 'react'
import { Pack, Product, ProductOption } from '../../model'
import Modal from '../Modal/Modal'
import { formatCurrencyValue } from '../../helpers/utils'
import { ExtendedProduct } from '../../services/api/orders'
import IconInCircle from '../IconInCircle/IconInCircle'
import ChoiceSelectItem from '../ChoiceSelectItem/ChoiceSelectItem'

interface ProductOptionsModalContentProps {
    product?: Product | Pack
    isPack?: boolean
    onRequestClose?(): void
    onConfirm?(product: ExtendedProduct | undefined, selectedOptions: ProductOption[]): void
}

const ProductOptionsModalContent: React.FunctionComponent<ProductOptionsModalContentProps> = ({
    product,
    isPack,
    onRequestClose,
    onConfirm
}: ProductOptionsModalContentProps) => {
    const [selectedOptions, setSelectedOptions] = useState<ProductOption[]>([])

    // @ts-ignore
    let products = isPack ? product?.products : [product]

    /**
     * Initialize selected options from product options.
     * This function is called on component mount and when the product changes.
     * It sets the selected options to the options which are marked as added
     * in the product's available options.
     */
    const initializeOptions = () => {
        if (!selectedOptions.length) {
            const options = isPack
                ? // @ts-ignore
                  product?.products?.map((p) => p.availableOptions).flat()
                : // @ts-ignore
                  product?.availableOptions
            setSelectedOptions(options?.filter((option: any) => option._isAdded) || [])
        }
    }

    const handleConfirm = () => {
        onConfirm && onConfirm(product, selectedOptions)
    }

    const handleClick = (option: ProductOption) => {
        if (option.exclusiveOption) {
            setSelectedOptions([option])
        } else {
            const isSelected = selectedOptions.map((o) => o.id).includes(option.id)
            if (isSelected) {
                setSelectedOptions(selectedOptions.filter((selectedOption) => selectedOption.id !== option.id))
            } else {
                setSelectedOptions([...selectedOptions, option])
            }
        }
    }

    useEffect(() => {
        // resetProductList()
        initializeOptions()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Modal
            buttonText='Bevestigen'
            onRequestClose={onRequestClose}
            onConfirm={handleConfirm}
            ariaLabel='Product opties selecteren'
            // disableConfirm={
            //     products.some((p: Product) => p.availableOptions?.some((o: ProductOption) => o.exclusiveOption)) &&
            //     selectedOptions.length === 0
            // }
        >
            <div className='px-4 pt-3 pb-0 bgPrimaryColor bg-opacity-5'>
                <div className='flex items-center  pb-3 border-b-2'>
                    <IconWithBackground iconName={product?.icon || 'geen'} aria-label={product?.name} />

                    {product && 'allowInvoice3RDParty' in product && product.allowInvoice3RDParty && (
                        <IconInCircle
                            icon={faReceipt}
                            size='small'
                            borderColor='borderGreenColor'
                            textColor='text-[--tb-green]'
                            bgColor='bg-white'
                            badge='bottom'
                        />
                    )}
                    <div className='textTbTextColor text-left ml-2'>
                        <p className='font-medium' aria-label={product?.name}>
                            {product?.name}
                        </p>
                        <p
                            className='text-xs text-opacity-50'
                            aria-label={product?.description || ''}
                            dangerouslySetInnerHTML={{ __html: product?.description || '' }}
                        ></p>
                    </div>
                </div>
            </div>

            <div className='text-left flex flex-col py-4 flex-grow overflow-auto'>
                <span className='font-normal px-6'>
                    {products.some((p: Product) => p.availableOptions?.some((o: ProductOption) => o.exclusiveOption))
                        ? 'Selecteer de gewenste optie:'
                        : 'Selecteer de gewenste opties:'}
                </span>

                {products
                    .filter((p: Product) => p.availableOptions && p.availableOptions.length > 0)
                    .map((p: Product) => {
                        return (
                            <div className='flex px-6 py-3 flex-col ' key={p.id}>
                                <h3 aria-label={p.name}>{p.name}</h3>
                                {p.availableOptions && p.availableOptions.length > 0 && (
                                    <ul className='flex flex-col mt-4 gap-y-2'>
                                        {p.availableOptions?.map((option: ProductOption) => {
                                            const isSelected = selectedOptions.map((o) => o.id).includes(option.id)

                                            return (
                                                <li key={option.id}>
                                                    <ChoiceSelectItem
                                                        id={option.id}
                                                        name={option.exclusiveOption ? `${p.id}` : option.name}
                                                        value={option}
                                                        isSingle={option.exclusiveOption}
                                                        isSelected={isSelected}
                                                        handleClick={handleClick}
                                                        formatLabel={() =>
                                                            `${option.name} (${formatCurrencyValue(option.price)})`
                                                        }
                                                    />
                                                </li>
                                            )
                                        })}
                                    </ul>
                                )}
                            </div>
                        )
                    })}
            </div>
        </Modal>
    )
}

export default ProductOptionsModalContent
